import { IHeadingClasses } from "./Heading";

export default <IHeadingClasses>{
  alignment: {
    center: "text-center",
    left: "text-left",
    right: "text-right",
  },
  boldness: {
    extralight: "font-extralight",
    light: "font-light",
    normal: "font-normal",
    med: "font-medium",
    semibold: "font-semibold",
    bold: "font-bold",
    extrabold: "font-extrabold",
  },
  textsize: {
    xs: "text-base",
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-3xl",
    "2xl": "text-4xl",
    "3xl": "text-5xl",
    "4xl": "text-4xl md:text-6xl",
    "5xl": "text-7xl",
    "6xl": "text-8xl",
    "7xl": "text-8xl",
  },
};
